import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import PlayersTable from '../common/PlayersTable';
import LoginModal from '../auth/LoginModal';
import RegisterModal from '../auth/RegisterModal';

const RightSidebar = () => {
  const { user } = useAuth();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [pendingPlayerPurchase, setPendingPlayerPurchase] = useState(null);

  // Fetch right sidebar data (tournament + players) from backend
  const { data: sidebarData, error, isLoading } = useQuery({
    queryKey: ['right-sidebar-players'],
    queryFn: async () => {
      const response = await api.get('/right-sidebar/players');
      return response.data;
    },
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });

  const openLoginModal = () => {
    setIsLoginModalOpen(true);
    setIsRegisterModalOpen(false);
  };

  const openRegisterModal = () => {
    setIsRegisterModalOpen(true);
    setIsLoginModalOpen(false);
  };

  const closeLoginModal = () => {
    setIsLoginModalOpen(false);
    setPendingPlayerPurchase(null);
  };

  const closeRegisterModal = () => {
    setIsRegisterModalOpen(false);
  };

  const handleBuyPlayer = (player) => {
    console.log(`Buying player: ${player.golfer.name} for $${player.price}`);
  };

  if (isLoading) return <p className='rightside-title'>Loading players...</p>;
  
  if (error) {
    console.error('Error loading sidebar data:', error);
    return <p className='rightside-title error'>Error loading players: {error.message}</p>;
  }
  
  if (!sidebarData?.data?.tournament) {
    return (
      <p className='rightside-title'>
        <span className='proskins-sidebar-title headingfont'>Tournament In Progress...</span>
      </p>
    );
  }

  return (
    <>
      <p className='rightside-title'>
        <span className="proskins-sidebar-title headingfont">WORLD RANKING</span>
        <span style={{ fontSize: 'var(--font-size-sm)', marginBottom: 'var(--spacing-sm)', marginLeft: '8px' }}>
          {sidebarData.data.tournament.name} - {new Date(sidebarData.data.tournament.startDate).toLocaleDateString('en-US')}
        </span>
      </p>

      <PlayersTable
        players={sidebarData?.data?.players || []}
        title=""
        showCount={false}
        linkToBetting={true}
        showBuyButton={true}
        tournament={sidebarData?.data?.tournament}
        user={user}
        onLoginRequired={openLoginModal}
        pendingPlayerPurchase={pendingPlayerPurchase}
        setPendingPlayerPurchase={setPendingPlayerPurchase}
      />

      <button className="proskins-btn proskins-btn-primary proskins-btn-full proskins-mt-md">
        VIEW MORE
      </button>

      {/* Login Modal */}
      <LoginModal 
        isOpen={isLoginModalOpen}
        onClose={closeLoginModal}
        onRegisterClick={openRegisterModal}
        pendingPlayerPurchase={pendingPlayerPurchase}
      />

      {/* Register Modal */}
      <RegisterModal 
        isOpen={isRegisterModalOpen}
        onClose={closeRegisterModal}
        onLoginClick={openLoginModal}
      />
    </>
  );
};

export default RightSidebar;
